import { size } from 'lodash';

export default {
    buttons: {
        start: '시작하기',
        end: '활동 종료하기',
        feedback: '콘텐츠 오류 신고',
        submit: '제출하기',
        next: '다음 문제',
        result: '결과 보기',
        nextModule: '다음으로',
        selfDone: '자습 완료',
        taskDone: '과제 완료',
        moduleStart: '활동 시작하기',
    },
    teacher: {
        setting: '활동 설정',
        wayOfProgress: '진행 방식',
        wayOfReading: '읽기 방식',
        title: '활동 제목',
        guide: '활동 가이드',
        tooltip: `
        <span class="tooltip_list">
            <strong>선생님과</strong>
            <span>선생님과 한 문제씩 진행해요</span>
         </span>
         <span class="tooltip_list">
            <strong>자기주도</strong>
            <span>학생이 전체 문제를 자기 속도로 풀어요</span>
        </span>            
        `,

        screen: '활동 화면',
        content: ({ values }: { values: { title?: string } }) => {
            const { title } = values;
            if (title) {
                return `활동 내용 <span>${title}</span>`;
            }
            return '활동 내용';
        },
        summary: '활동 요약',
        addQuestions: {
            search: {
                empty: '✨검색창에 어휘를 입력하면 사전 검색 결과가 여기 나와요.\n시트에서 복사한 데이터를 검색창에 붙여넣으면\n곧바로 등록 대기 어휘에 추가됩니다.',
                placeholder: '어휘를 검색하거나, Excel / 구글 스프레드시트에서 데이터를 복사, 붙여넣기',
            },
            wait: {
                empty: {
                    default: '담긴 어휘가 모이면 [활동에 등록] 한 번으로 함께 추가됩니다.',
                    choice: '담긴 어휘가 모이면 [활동에 등록] 한 번으로 함께 추가됩니다.\n대기 어휘의 오답 선지는 비워두면 활동에 등록할 때\n다른 어휘에서 자동으로 채워집니다.\n시트 데이터는 어휘 / 뜻 / 오답1 / 오답2 / 오답3 컬럼 순서로 받습니다.',
                },
            },
            infoTitle: '원하는 어휘를 검색해 나만의 문항을 추가할 수 있어요.',
            infoDesc: {
                default: '엑셀·구글 시트에서 복사해 붙여넣으면 한 번에 등록됩니다!',
                choice: '엑셀·구글 시트에서 복사해 붙여넣으면 한 번에 등록되고,\n오답 선지가 비어있으면 자동으로 채워집니다!',
            },
            noMeaning: {
                title: '뜻이 없는 어휘가 있어요!',
                message: '뜻이 없는 어휘가 있습니다.<br />이 어휘를 제외하고 나머지만 등록할까요?',
                enterMeaning: '뜻 입력하기',
                submitRest: '나머지만 등록',
            },
            invalidChar: {
                title: '올바르지 않은 기호가 있어요!',
                message: '뜻에는 한글, 영문, 숫자와 일부 기호만 입력할 수 있습니다.',
                invalidCharsLabel: '입력된 내용 중 허용되지 않는 문자:',
            },
            registerResult: '등록 결과',
        },
    },
    alert: {
        wrong: '앗 틀렸어요. 다시 시도해 보세요.',
        chancesExhausted: '앗 틀렸어요! 정답을 확인해 보세요.',
        waiting: () => {
            const messages = [
                '다 했어요! 이제 잠시 기다려주세요.',
                '좋아요! 이제 잠시 기다려주세요.',
                '잘했어요! 잠시만 기다려주세요.',
            ];
            return messages[Math.floor(Math.random() * size(messages))];
        },
    },
    question: '문항',
    answerRate: '정답률',
    relation: '{relation} 관계',
    allDone: '모든 문항을 진행했어요. 활동을 종료해 주세요!',
    champion: '챔피언',
    allSelect: '모두 선택',
    majorVocabulary: '주요 어휘',
    remainingVocabulary: '나머지 어휘',
    customVocabulary: '내가 추가한 어휘',
    goWatingroom: '전체 학생 대기실로 이동',
    students: {
        errorTooltip: '학생이 오프라인 상태예요',
        progress: {
            title: ({ values }: { values: { isOngoing: boolean } }) => {
                const { isOngoing } = values;
                return `학생별 ${isOngoing ? '현황' : '결과'}`;
            },
        },
        standby: '진행 전',
        notAttended: '미참여',
        inProgress: '진행 중',
        notCompleted: '미완료',
        completed: '완료',
    },
    modal: {
        title: '활동 종료',
        message: '활동을 종료할까요?',
    },
    feedbackModal: {
        title: '콘텐츠 피드백 보내기',
        description: '활동을 진행하며 발견한 학습 콘텐츠 오류를 운영팀에 바로 신고합니다.',
        questionLabel: '문항',
        optional: '(선택)',
        required: '(필수)',
        selectAll: '전체',
        activityAll: '활동 전체',
        contentLabel: '내용',
        contentPlaceholder: '어떤 문항/부분에서 무엇이 잘못됐는지 적어주세요. (예: 3번 문항 정답 오류)',
        screenshotLabel: '스크린샷 첨부',
        screenshotOptional: '(선택)',
        screenshotHint: '이미지를 끌어다 놓거나 클릭해서 첨부',
        attachmentHint: 'JPG, PNG, GIF, WEBP · 최대 5장, 장당 3MB',
        attachmentTooMany: '이미지는 최대 5장까지 첨부할 수 있어요.',
        attachmentTooLarge: '이미지 1장은 3MB 이하만 첨부할 수 있어요.',
        attachmentInvalidType: 'JPG, PNG, GIF, WEBP 형식만 첨부할 수 있어요.',
        cancel: '취소',
        submit: '피드백 보내기',
        submitSuccess: '콘텐츠 피드백이 접수되었어요.',
        submitError: '피드백 전송에 실패했어요. 잠시 후 다시 시도해 주세요.',
    },
    state: {
        correct: '정답',
        wrong: '오답',
    },
    toast: {
        addStarStudent: '{name} 학생에게 칭찬별을 주었습니다',
        addAllStar: '전체 학생({length}명)에게 칭찬별을 주었습니다',
        failedStar: '칭찬별 지급에 실패했습니다',
        undo: '실행 취소',
        undoFailed: '칭찬별 실행 취소에 실패했습니다',
        movedToWaitingRoom: '학생들이 모두 대기실로 이동했습니다.',
    },
};
